import { router } from '@lib/router'
import {
  NavigateOptions,
  useLocation,
  useNavigate,
} from '@tanstack/react-router'

export const useAppNavigate = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const appNavigate = (options: NavigateOptions) => {
    const { search, ...restOptions } = options
    const newSearch = typeof search === 'boolean' ? {} : search
    navigate({
      search: { ...location.search, ...newSearch },
      ...restOptions,
    })
  }

  return appNavigate
}

export const appNavigate = (options: NavigateOptions) => {
  router.navigate({ search: router.state.location.search, ...options })
}
